import { Component, Input } from '@angular/core';
import { NonConformanceModel } from 'chronos-core-client';

@Component({
  selector: 'app-nc-reason',
  templateUrl: './nc-reason.component.html',
  styleUrls: ['./nc-reason.component.scss']
})
export class NcReasonComponent {
  @Input() public nonConformanceModel: NonConformanceModel;

  @Input() public isCreateNCMode: boolean;
}
